import React from 'react';
import { platformContent } from '../data/mock';
import { getImageUrl } from '../lib/api';
import { LayoutDashboard, Wrench, Users } from 'lucide-react';

const iconMap = {
  1: LayoutDashboard,
  2: Wrench,
  3: Users
};

const labels = {
  1: "Vadības panelis",
  2: "Uzturēšana",
  3: "Lietotāja plūsma"
};

const PlatformSection = () => {
  return (
    <section className="py-20 lg:py-32 bg-white" id="platform">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
            {platformContent.title}
          </h2>
          <div className="w-16 h-1 bg-slate-800 mx-auto" />
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {platformContent.images.map((item) => {
            const Icon = iconMap[item.id] || LayoutDashboard;
            return (
              <div
                key={item.id}
                className="group"
              >
                <div className="aspect-[4/3] bg-slate-100 rounded-xl overflow-hidden mb-4 shadow-lg group-hover:shadow-xl transition-shadow">
                  <img
                    src={getImageUrl(item.src)}
                    alt={item.altText}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.parentElement.classList.add('flex', 'items-center', 'justify-center');
                      e.target.parentElement.innerHTML = `<div class="text-slate-400 text-center p-8"><div class="w-16 h-16 mx-auto mb-4 bg-slate-200 rounded-lg flex items-center justify-center"><svg class="w-8 h-8 text-slate-300" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z"></path></svg></div><span class="text-sm">Platformas ekrānuzņēmums</span></div>`;
                    }}
                  />
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center">
                    <Icon className="w-5 h-5 text-white" />
                  </div>
                  <h3 className="font-semibold text-slate-900">
                    {labels[item.id]}
                  </h3>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PlatformSection;
